"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var config_1 = require("../config/config");
var phone_authentication_popup_template_1 = require("../templates/phone-authentication-popup.template");
var storefront_service_1 = require("../services/storefront.service");
var store_checkout_selectors_1 = require("../store/checkout/store-checkout-selectors");
var CheckoutPhoneAuthentication = /** @class */ (function () {
    function CheckoutPhoneAuthentication() {
        this.store = window[config_1["default"].storeKey];
        this.$body = $(this.store.selectors.body);
        this.storefrontService = new storefront_service_1["default"]();
        this.appCustomerId = '';
        this.customerPhoneNumber = '';
        this.phoneVerificationCode = '';
        try {
            this.init();
        }
        catch (err) {
            console.log('Can not init phone authentication');
        }
    }
    CheckoutPhoneAuthentication.prototype.init = function () {
        var isLoggedInCustomer = $(this.store.selectors.isLoggedInCustomerInput).val() === 'true';
        if (isLoggedInCustomer) {
            if (window.location.href.indexOf('displayLogInSuccessPopup=true') !== -1) {
                this.initCustomerSuccess();
            }
        }
        else {
            // @ts-ignore
            if (window.Shopify.Checkout.step === 'contact_information') {
                this.initGuest();
            }
        }
        this.bindEvents();
    };
    CheckoutPhoneAuthentication.prototype.initCustomerSuccess = function () {
        var _this = this;
        console.log('initCustomerSuccess');
        var html = phone_authentication_popup_template_1["default"](this.store.translations.checkout.steps.phone.title, this.store.translations.checkout.steps.phone.text);
        $(this.store.selectors.body).append(html);
        this.showStepSignIn();
        setTimeout(function () {
            $(_this.store.selectors.checkout.popup).show();
        }, 1);
        this.populatePhoneNumberFromSessionStorage();
    };
    CheckoutPhoneAuthentication.prototype.initGuest = function () {
        var _this = this;
        var html = phone_authentication_popup_template_1["default"](this.store.translations.checkout.steps.phone.title, this.store.translations.checkout.steps.phone.text);
        $(this.store.selectors.body).append(html);
        setTimeout(function () {
            $(_this.store.selectors.checkout.popup).show();
        }, 2000);
    };
    CheckoutPhoneAuthentication.prototype.bindEvents = function () {
        var _this = this;
        var $popup = $(this.store.selectors.checkout.popup);
        this.$body.on('click', this.store.selectors.checkout.popup, function (e) {
            if (e.target.classList.contains(store_checkout_selectors_1.popupClass)) {
                $popup.hide();
            }
        });
        this.$body.on('click', this.store.selectors.checkout.noAccountLink, function (e) {
            window.location.href = _this.store.shopUrl + '/account/login';
        });
        this.$body.on('click', this.store.selectors.checkout.submitPhoneBtn, function (e) {
            _this.onSubmitPhoneNumberEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.submitCodeBtn, function (e) {
            _this.onSubmitVerificationCodeEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.emailBtnYes, function (e) {
            _this.onClickEmailUpdateYesEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.emailRetryLink, function (e) {
            _this.onClickEmailUpdateYesEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.emailBtnNo, function (e) {
            _this.onSignMeInEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.submitEmailUpdateBtn, function (e) {
            _this.onSubmitEmailUpdateEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.submitEmailCodeBtn, function (e) {
            _this.onSubmitEmailCodeEvent();
        });
        this.$body.on('click', this.store.selectors.checkout.signMeInBtn, function (e) {
            $popup.hide();
        });
        this.$body.on('click', this.store.selectors.checkout.continueWithoutLoggingInBtn, function (e) {
            $popup.hide();
        });
        this.$body.on('click', this.store.selectors.checkout.defaultLoginLink, function (e) {
            e.preventDefault();
            $popup.show();
        });
        this.$body.on('keyup', this.store.selectors.checkout.stepPhone, function (e) {
            _this.onPhoneNumberKeyUpEvent(e);
        });
        this.$body.on('click', this.store.selectors.checkout.phoneNotFoundTryAgainBtn, function (e) {
            _this.showStepPhone('');
        });
        this.$body.on('keyup', this.store.selectors.checkout.phoneInput, function (e) {
            _this.onPhoneNumberField1KeyUpEvent(e);
        });
    };
    CheckoutPhoneAuthentication.prototype.onPhoneNumberKeyUpEvent = function (e) {
        var target = e.target;
        var maxLength = parseInt(target.attributes["maxlength"].value, 10);
        var myLength = target.value.length;
        if (myLength >= maxLength) {
            var next = target;
            while (next = next.nextElementSibling) {
                if (next == null)
                    break;
                if (next.tagName.toLowerCase() === "input") {
                    next.focus();
                    break;
                }
            }
        }
        else if (myLength === 0 && e.key === "Backspace") {
            var previous = target;
            while (previous = previous.previousElementSibling) {
                if (previous == null)
                    break;
                if (previous.tagName.toLowerCase() === "input") {
                    previous.focus();
                    break;
                }
            }
        }
    };
    CheckoutPhoneAuthentication.prototype.onPhoneNumberField1KeyUpEvent = function (e) {
        var value = e.target.value;
        sessionStorage.setItem(this.store.sessionStorageKeys.phoneField1Name, value);
        $(this.store.selectors.checkout.shippingPhoneInput1).val(value);
    };
    CheckoutPhoneAuthentication.prototype.onSubmitPhoneNumberEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var phoneNumberField1, phoneNumber, response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        phoneNumberField1 = $(this.store.selectors.checkout.phoneInput).val().toString();
                        phoneNumber = '+'
                            + $(this.store.selectors.account.phoneNumberCodeSelect).val().toString()
                            + phoneNumberField1;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.storefrontService.get('customers/authentication/phone/' + phoneNumber)];
                    case 2:
                        response = _a.sent();
                        if (response.data.status !== 'Valid') {
                            this.showStepPhoneNotFound(response.data.msg);
                            return [2 /*return*/];
                        }
                        this.appCustomerId = response.data.customerId;
                        this.showStepCode(response.data.msg);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        alert('系統發生錯誤，請再試一次');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CheckoutPhoneAuthentication.prototype.onSubmitVerificationCodeEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.phoneVerificationCode = $(this.store.selectors.checkout.codeInput).val().toString();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.storefrontService.get('customers/authentication/phone-code/' + this.phoneVerificationCode + '/' + this.appCustomerId)];
                    case 2:
                        response = _a.sent();
                        if (response.data.status !== 'Valid') {
                            if (response.data.msg === '您的驗證碼已失效，請再次輸入電話號碼') {
                                this.showStepPhone('請以您的手機號碼登入帳戶，若曾以其他方式登入，請輸入您入會登記的手機號碼並完成認證，即可查詢會員資訊並享有折扣');
                            }
                            alert(response.data.msg);
                            return [2 /*return*/];
                        }
                        if (response.data.url) {
                            window.location.href = response.data.url;
                        }
                        else {
                            this.updatePopupTitle('確認成功!');
                            this.updatePopupText(response.data.msg);
                            this.showStepEmail();
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        alert('系統發生錯誤，請再試一次');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CheckoutPhoneAuthentication.prototype.onSubmitEmailUpdateEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newEmail, response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newEmail = $(this.store.selectors.checkout.emailUpdateInput).val().toString();
                        if (!this.validateEmail(newEmail)) {
                            alert('email不存在');
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.storefrontService.get('customers/authentication/email/' + encodeURIComponent(newEmail) + '/' + this.appCustomerId)];
                    case 2:
                        response = _a.sent();
                        if (response.data.status !== 'Valid') {
                            alert(response.data.msg);
                            return [2 /*return*/];
                        }
                        this.showStepEmailCode(response.data.msg);
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        alert('系統發生錯誤，請再試一次');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CheckoutPhoneAuthentication.prototype.onSubmitEmailCodeEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var verificationCode, response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        verificationCode = $(this.store.selectors.checkout.emailCodeInput).val();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.storefrontService.get('customers/authentication/email-code/' + verificationCode + '/' + this.appCustomerId)];
                    case 2:
                        response = _a.sent();
                        if (response.data.status !== 'Valid') {
                            alert(response.data.msg);
                            return [2 /*return*/];
                        }
                        window.location.href = response.data.url;
                        return [3 /*break*/, 4];
                    case 3:
                        err_4 = _a.sent();
                        alert('系統發生錯誤，請再試一次');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CheckoutPhoneAuthentication.prototype.onSignMeInEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.storefrontService.get('customers/authentication/multipass/' + this.phoneVerificationCode + '/' + this.appCustomerId)];
                    case 1:
                        response = _a.sent();
                        if (response.data.status !== 'Valid') {
                            alert(response.data.msg);
                            return [2 /*return*/];
                        }
                        window.location.href = response.data.url;
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        alert('系統發生錯誤，請再試一次');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CheckoutPhoneAuthentication.prototype.validatePhoneNumber = function (phoneNumber) {
        var isnum = /^\d+$/.test(phoneNumber);
        if (!isnum) {
            alert('手機號碼必須為數字');
            return false;
        }
        if (phoneNumber.length !== 8) {
            alert('請輸入手機號碼後8碼');
            return false;
        }
        return true;
    };
    CheckoutPhoneAuthentication.prototype.updatePopupTitle = function (title) {
        $(this.store.selectors.checkout.popupTitle).text(title);
    };
    CheckoutPhoneAuthentication.prototype.updatePopupText = function (text) {
        $(this.store.selectors.checkout.popupText).html(text);
    };
    CheckoutPhoneAuthentication.prototype.hideAllSteps = function () {
        $(this.store.selectors.checkout.step).hide();
    };
    CheckoutPhoneAuthentication.prototype.showStepPhone = function (withErrText) {
        this.updatePopupTitle(this.store.translations.checkout.steps.phone.title);
        var text = this.store.translations.steps.phone.text;
        if (withErrText) {
            text = withErrText;
        }
        this.updatePopupText(text);
        this.hideAllSteps();
        $(this.store.selectors.checkout.stepPhone).show();
    };
    CheckoutPhoneAuthentication.prototype.showStepPhoneNotFound = function (msg) {
        this.updatePopupTitle('');
        this.updatePopupText('');
        this.hideAllSteps();
        $(this.store.selectors.checkout.phoneNotFoundErrorMsg).text(msg);
        $(this.store.selectors.checkout.stepPhoneNotFound).show();
    };
    CheckoutPhoneAuthentication.prototype.showStepCode = function (msg) {
        this.updatePopupTitle(this.store.translations.checkout.steps.phoneCode.title);
        this.updatePopupText(msg);
        this.hideAllSteps();
        $(this.store.selectors.checkout.stepCode).show();
    };
    CheckoutPhoneAuthentication.prototype.showStepEmail = function () {
        this.hideAllSteps();
        $(this.store.selectors.checkout.stepEmail).show();
    };
    CheckoutPhoneAuthentication.prototype.showStepEmailUpdate = function () {
        this.hideAllSteps();
        $(this.store.selectors.checkout.stepEmailUpdate).show();
    };
    CheckoutPhoneAuthentication.prototype.showStepEmailCode = function (msg) {
        this.updatePopupTitle(this.store.translations.checkout.steps.emailCode.title);
        this.updatePopupText(msg);
        this.hideAllSteps();
        $(this.store.selectors.checkout.stepEmailCode).show();
    };
    CheckoutPhoneAuthentication.prototype.showStepSignIn = function () {
        this.updatePopupTitle(this.store.translations.checkout.steps.signIn.title);
        this.updatePopupText(this.store.translations.checkout.steps.signIn.text);
        this.hideAllSteps();
        $(this.store.selectors.checkout.stepSignIn).show();
    };
    CheckoutPhoneAuthentication.prototype.onClickEmailUpdateYesEvent = function () {
        this.updatePopupTitle('email 認證');
        this.updatePopupText('請輸入您的 email');
        this.showStepEmailUpdate();
    };
    CheckoutPhoneAuthentication.prototype.populatePhoneNumberFromSessionStorage = function () {
        var phoneField1Value = sessionStorage.getItem(this.store.sessionStorageKeys.phoneField1Name);
        var shippingPhoneField1 = document.querySelector(this.store.selectors.checkout.shippingPhoneInput1);
        if (shippingPhoneField1) {
            shippingPhoneField1.value = phoneField1Value;
        }
    };
    CheckoutPhoneAuthentication.prototype.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    return CheckoutPhoneAuthentication;
}());
exports["default"] = CheckoutPhoneAuthentication;
